<template>
    <div class="msg border rounded mt-2 mb-2" v-if="visible" v-bind:class="{ 'border-warning': critical }">
        <b-icon-exclamation-triangle v-if="critical" variant="warning" class="icon h2 m-2 ml-3"></b-icon-exclamation-triangle>
        <b-icon-exclamation-circle v-if="!critical" variant="info" class="icon h2 m-2 ml-3"></b-icon-exclamation-circle>
        <div v-if="code === 1001" class="text text-body">
            <i18n path="error.1001" tag="label" for="error.actions.fix">
                <template v-slot:action>
                    <router-link :to="{ path: '/dashboard/profile/auth', hash: '#user-password' }" >{{ $t('error.actions.fix') }}</router-link>
                </template>
            </i18n>
        </div>
        <div v-else-if="code === 1002" class="text text-body">
            <i18n path="error.1002" tag="label" for="error.actions.fix">
                <template v-slot:action>
                    <router-link :to="{ path: '/dashboard/profile/comm', hash: '#user-email' }" >{{ $t('error.actions.fix') }}</router-link>
                </template>
            </i18n>
        </div>
        <div v-else class="text text-body">{{ message }}</div>
        <div v-if="!critical" v-b-hover="handleHover" class="button">
            <b-icon-x v-if="!isHovered" variant="info" scale="1.75"></b-icon-x>
            <b-icon-x v-else variant="dark" scale="1.75"></b-icon-x>
        </div>
    </div>
</template>


<script>
    import { BIconExclamationTriangle, BIconExclamationCircle, BIconX } from "bootstrap-vue";
    export default {
        name: "WarningOrMessage",
        components: {
            BIconExclamationTriangle, BIconExclamationCircle, BIconX
        },
        props: {
            "visible": {
                type: Boolean,
                default: true
            },
            "code": {
                type: Number,
                default: 0
            },
            "message": {
                type: String,
                default: ""
            },
            "critical": {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isHovered: false
            }
        },
        methods: {
            handleHover(hovered) {
                this.isHovered = hovered
            }
        }
    }
</script>

<style scoped>
    .msg {
        display: flex;
        padding: 0.5rem;
    }
    .msg .text {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 15px;
    }
    .msg .text label {
        margin: 0 1rem 0 0;
    }
    .msg .button {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0 0.5rem 0 1.5rem;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
</style>